import { t } from '@lingui/core/macro';
import * as yup from 'yup';
import { AssistantChatKind } from 'shared/domains/apollo/generated/types';
const tabularContent = () => yup.array(yup.object({
    id: yup.string().required(),
    name: yup
        .string()
        .trim()
        .required(t({
        message: 'Column name is required.',
        comment: 'Validation message in create/update prompt modal for property `description`',
    })),
    description: yup.string().trim(),
}));
const regularContent = () => yup.string().trim();
export const makeValidationSchema = () => yup.object({
    name: yup
        .string()
        .trim()
        .required(t({
        comment: 'Prompt name is required validation message in create/update prompt modal for property `name`',
        message: 'Prompt name is required.',
    }))
        .max(70, t({
        comment: 'Prompt name is too long validation message in create/update prompt modal for property `name`',
        message: 'Prompt name is too long.',
    })),
    content: yup.mixed().when('kind', {
        is: AssistantChatKind.Regular,
        then: regularContent().required(t({
            comment: 'Validation message in create/update prompt modal for property `description`',
            message: 'Prompt description is required.',
        })),
    }),
    tabularContent: yup.mixed().when('kind', {
        is: AssistantChatKind.Tabular,
        then: tabularContent().required(t({
            comment: 'Validation message in create/update prompt modal for property `description`',
            message: 'Prompt description is required.',
        })),
    }),
    isPublic: yup.bool().required(),
    labels: yup.array(yup.string().trim().required()).required(),
    kind: yup
        .string()
        .oneOf([AssistantChatKind.Regular, AssistantChatKind.Tabular, AssistantChatKind.ApprovalWorkflow])
        .required(),
});
